import React, { useState, useEffect } from "react";
import Modal from "../../Common/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useContext } from "react";
import { RootContext } from "../../../index";
import { observer } from "mobx-react-lite";
import { Outlet, useNavigate } from "react-router-dom";
import { Spinner } from "../../Common/Spinner";
import { DataTable3 } from "../../Server/DataTable3";
import Form, { FormBody, TextInput } from '../../Common/Form';


const ConfigMetaData = observer(() => {
    const rootStore = useContext(RootContext);
    const tagStore = rootStore.tagStore;

    const [showAddTags, setShowAddTags] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);


    const navigate = useNavigate();

    useEffect(() => {
        tagStore.fetchMetaData();
    }, []);

    const [metaDataInfo, setMetaDataInfo] = useState({
        name: "",
        description: "",
    });

    const setNewForm = (e) => {
        const { name, value } = e.target;
        setMetaDataInfo((prev) => ({ ...prev, [name]: value }));
    };

    const addMetaData = async (e) => {
        e.preventDefault();
        if (!metaDataInfo.name || !metaDataInfo.description) {
            toast.error("Missing fields");
            return;
        }
        const addedmetaDataInfo = await tagStore.postMetaData(metaDataInfo);
        console.log(addedmetaDataInfo, "addedmetadat");

        if (!addedmetaDataInfo.id) {
            await tagStore.fetchMetaData();

            setMetaDataInfo({ name: "", description: "" });
        }

        setShowAddTags(false)
    };


    const deleteSelectedPlans = async (e) => {
        const confirm = window.confirm("Delete selected plans?");
        if (selectedRows.length != 0 && confirm) {
            await Promise.all(selectedRows.map((id) => tagStore.deleteMetaData(id)));
            setSelectedRows([]);
        } else if (confirm) {
            await tagStore.deleteMetaData(e);
        }
    };

    const toggleCheckbox = (id) => {
        const isSelected = selectedRows.includes(id);

        if (isSelected) {
            setSelectedRows((prevRows) => prevRows.filter((rowId) => rowId !== id));
        } else {
            setSelectedRows((prevRows) => [...prevRows, id]);
        }
    };



    const handleCheckboxChange = (id) => {
        const isSelected = selectedRows.includes(id);

        if (isSelected) {
            setSelectedRows((prevRows) => prevRows.filter((rowId) => rowId !== id));
        } else {
            setSelectedRows((prevRows) => [...prevRows, id]);
        }

        handleCheckboxChange && handleCheckboxChange(selectedRows);
    };

    return (
        <div>
            <DataTable3
                data={tagStore.meta_data
                    .map((item, index) => {
                        return {
                            ...item,
                            SN: index + 1,
                        }
                    })

                }
                headers={[
                    { key: "SN", label: "SN" },
                    { key: "name", label: "Name" },
                    { key: "description", label: "Description" }
                ]}
                handleAdd={() => setShowAddTags(true)}
                // handleEdit={(id) => {
                //     navigate(`/configuration/plan/${id}`);
                // }}
                handleDelete={(e) => deleteSelectedPlans(e)}
                handleCheckboxChange={(id) => toggleCheckbox(id, selectedRows, setSelectedRows)}
            />

            {showAddTags && (
                <Modal
                    title={"Add Meta Data"}
                    closeModal={() => {
                        setShowAddTags(false);
                        setMetaDataInfo({ name: "", description: "" });
                    }}
                >

                    <Form>
                        <FormBody>
                            <TextInput label={'Name'} name="name"  value={metaDataInfo.name} onChange={setNewForm} />
                            <TextInput label={'Description'} name="description" value={metaDataInfo.description} onChange={setNewForm} />
                            <br/>
                            <button onClick={(e) => addMetaData(e)}>Submit</button>
                        </FormBody>
                    </Form>
                </Modal>
            )}
            <Outlet />
        </div>

    );
});


export default ConfigMetaData
